import { Grid, GridProps } from '@mui/material';

const DefaultSpacingGrid = (props: GridProps) => {
    const { spacing = 2, ...rest } = props;
    return <Grid spacing={spacing} {...rest} />;
};

export default DefaultSpacingGrid; 